'use client';

import { useEffect, useState } from 'react';

type UseFireworksParams = {
  isBigGain: boolean;
  enableFireworks: boolean;
  baseDelay?: number;
  delayBetween?: number;
};

export const useFireworks = ({
  isBigGain,
  enableFireworks,
  baseDelay = 1.3,
  delayBetween = 0.5,
}: UseFireworksParams) => {
  const [showFireworks, setShowFireworks] = useState<boolean[]>([]);

  useEffect(() => {
    if (isBigGain && enableFireworks) {
      setShowFireworks([false, false]);
      const delays = [baseDelay, baseDelay + delayBetween];
      const timeouts: ReturnType<typeof setTimeout>[] = [];

      delays.forEach((delay, index) => {
        const timeout = setTimeout(() => {
          setShowFireworks((prev) => {
            if (prev.length !== 2) {
              return prev;
            }
            const newState = [...prev];
            newState[index] = true;
            return newState;
          });
        }, delay * 1000);
        timeouts.push(timeout);
      });

      return () => {
        timeouts.forEach((timeout) => clearTimeout(timeout));
      };
    } else {
      setShowFireworks([]);
    }
  }, [isBigGain, enableFireworks, baseDelay, delayBetween]);

  return { showFireworks };
};
